import { render, staticRenderFns } from "./BankTransfers.vue?vue&type=template&id=317c4fac&"
import script from "./BankTransfers.vue?vue&type=script&lang=ts&"
export * from "./BankTransfers.vue?vue&type=script&lang=ts&"
import style0 from "./BankTransfers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports